// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Topic":"Topic-3EvqJVTD"};